import { render, staticRenderFns } from "./Releasenotes.vue?vue&type=template&id=3c2e0032&scoped=true"
import script from "./Releasenotes.vue?vue&type=script&lang=js"
export * from "./Releasenotes.vue?vue&type=script&lang=js"
import style0 from "./Releasenotes.vue?vue&type=style&index=0&id=3c2e0032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e0032",
  null
  
)

export default component.exports